export const REGEXP = {
  withoutNumber: /\D/g,
  withoutLatinNumber: /[^A-Za-z0-9]/g,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  emailEnter: /[^a-zA-Z0-9._%+-@]/g,
};
